// Size guide drawer: opens from the size option on product pages (snippets/size-guide.liquid)
(() => {
  if (window.apriSizeGuide) return;
  window.apriSizeGuide = true;

  const build = (dialog) => {
    const view = dialog.querySelector('[data-size-guide-view]');
    const source = dialog.querySelector('[data-size-guide-source]');
    if (!view || !source || view.dataset.built) return;
    view.dataset.built = 'true';

    const nodes = Array.from(source.content.childNodes);
    const index = Number(dialog.dataset.sizeGuideIndex);
    const garmentHeadings = nodes.filter((node) => node.nodeName === 'H3');
    const keep = [];

    if (index >= 0 && garmentHeadings[index]) {
      // Body measurements + "Garment measurements" intro + this product's table only
      let section = 'intro';
      let currentH3 = -1;
      for (const node of nodes) {
        if (node.nodeName === 'H3') {
          currentH3 += 1;
          section = currentH3 === index ? 'product' : 'other';
        }
        if (section !== 'other') keep.push(node);
      }
    } else {
      keep.push(...nodes);
    }

    for (const node of keep) view.append(node.cloneNode(true));
    view.querySelectorAll('meta').forEach((meta) => meta.remove());
    view.querySelectorAll('table').forEach((table) => {
      table.removeAttribute('width');
      const wrap = document.createElement('div');
      wrap.className = 'size-guide-table-wrap';
      table.replaceWith(wrap);
      wrap.append(table);
    });
  };

  const close = (dialog) => {
    if (dialog?.open) dialog.close();
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-size-guide-open], a[href="#size-guide"]');
    if (opener) {
      const dialog = opener.dataset.sizeGuideOpen
        ? document.getElementById(opener.dataset.sizeGuideOpen)
        : document.querySelector('.size-guide-dialog');
      if (!dialog) return;
      event.preventDefault();
      build(dialog);
      dialog.showModal();
      dialog.querySelector('.size-guide-dialog__body')?.scrollTo(0, 0);
      return;
    }

    if (event.target.closest('[data-size-guide-close]')) {
      close(event.target.closest('dialog'));
      return;
    }

    // Click on the backdrop (outside the panel) closes the drawer
    if (event.target instanceof HTMLDialogElement && event.target.classList.contains('size-guide-dialog')) {
      close(event.target);
    }
  });

  // Deep link: product-url#size-guide opens the drawer directly (e.g. from emails)
  const openFromHash = () => {
    if (window.location.hash !== '#size-guide') return;
    const dialog = document.querySelector('.size-guide-dialog');
    if (!dialog || dialog.open) return;
    build(dialog);
    dialog.showModal();
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openFromHash);
  } else {
    openFromHash();
  }
  window.addEventListener('hashchange', openFromHash);

  // Swipe down on the header to close (mobile bottom sheet)
  let startY = null;
  document.addEventListener('touchstart', (event) => {
    const handle = event.target.closest('[data-size-guide-handle]');
    startY = handle ? event.touches[0].clientY : null;
  }, { passive: true });

  document.addEventListener('touchend', (event) => {
    if (startY === null) return;
    const delta = event.changedTouches[0].clientY - startY;
    if (delta > 60) close(event.target.closest('dialog'));
    startY = null;
  }, { passive: true });
})();
